module.exports = __webpack_public_path__ + "img/background-waves.c5ab9357.svg";